// extracted by mini-css-extract-plugin
export default {"form":"styles_form__C16VM","container":"styles_container__cs1sh","input":"styles_input__+6S56","image":"styles_image__6GAT9","headerContainer":"styles_headerContainer__RJ1h3"};